module.exports = __webpack_public_path__ + "static/media/german.bddbcbd1.png";